export default __webpack_public_path__ + "static/media/sucesso.da5d981a.svg";